import classNames from 'classnames';
import { FC, memo } from 'react';
import { PaginationDirection, PaginationType, TPaginationType } from '../../types';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import '../PaginationButton/style.scss';

interface IProps {
  direction: PaginationDirection;
  buttonType: TPaginationType;
  disabled: boolean;
  changePage: () => void;
}

const PaginationDirectionButton: FC<IProps> = ({ direction, buttonType, disabled, changePage }: IProps): JSX.Element => {
  const isArrowType: boolean = buttonType === PaginationType.ARROW;
  const buttonClassName: string = classNames('pagination__button', { 'pagination__button-arrow': isArrowType });

  return (
    <button className={buttonClassName} onClick={changePage} disabled={disabled}>
      {isArrowType ? (
        <Icon name={direction === PaginationDirection.PREV ? Icons.ExpandLeft : Icons.ExpandRight} className="rotated" size={24} />
      ) : (
        localeStore.t(direction)
      )}
    </button>
  );
};

export default memo(PaginationDirectionButton);
